import { z } from 'zod';

import { integerAndFloatNumbersWithNegativesRegex } from 'constants/regex';

const amountMaxValue = 99999.99;

const validationSchema = z.object({
  ticketId: z.string(),
  ticketRoofTopId: z.string().uuid(),
  amount: z
    .string()
    .min(1, 'Please enter a valid amount')
    .regex(integerAndFloatNumbersWithNegativesRegex, {
      message: 'Only integer or decimal numbers allowed',
    })
    .refine(
      val => {
        const amountValue = parseFloat(val);
        return amountValue <= amountMaxValue;
      },
      { message: 'Please enter an amount less than or equal to 99999.99' }
    )
    .refine(
      val => {
        const decimalPart = val.split('.')[1];
        return !decimalPart || decimalPart.length <= 2; // Allow up to 2 decimal places
      },
      { message: 'Please enter an amount with no more than 2 decimal places' }
    ),
  claimStatusId: z
    .number({ required_error: 'Please select a claim status' })
    .min(0, 'Please select a claim status'),
  claimSubmittedDate: z.date().nullable().optional(),
  advisorNumber: z
    .string()
    .max(50, 'Advisor number must not exceed 50 characters.')
    .nullable()
    .optional(),
  techNumber: z
    .string()
    .max(50, 'Tech number must not exceed 50 characters.')
    .nullable()
    .optional(),
  subCategoryId: z.number().nullable().optional(),
  ticketPriorityId: z
    .number({ required_error: 'Please select a priority' })
    .min(0, 'Please select a priority'),
});

export default validationSchema;
